import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { LogOut, LayoutGrid, Settings, BookOpen } from "lucide-react";
import { useAuth, LOGO_URL } from "../context/AuthContext";

export default function TopNav() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const initial = (user?.first_name || user?.email || "?")[0].toUpperCase();

    const navClass = ({ isActive }) =>
        [
            "font-display text-sm sm:text-base px-3 py-2 brut-border",
            isActive
                ? "bg-[#E8241A] text-white"
                : "bg-white text-black hover:bg-black hover:text-white",
        ].join(" ");

    const handleLogout = async () => {
        await logout();
        navigate("/login");
    };

    return (
        <header
            className="sticky top-0 z-40 bg-white border-b-4 border-black"
            data-testid="top-nav"
        >
            <div className="max-w-7xl mx-auto flex items-center justify-between gap-3 px-4 sm:px-6 lg:px-8 py-3">
                <Link
                    to="/dashboard"
                    className="flex items-center gap-3 min-w-0"
                    data-testid="nav-logo-link"
                >
                    {/* Red card with black outline + shadow — matches login hero */}
                    <div className="bg-[#E8241A] brut-border brut-shadow-sm p-1.5 shrink-0">
                        <img
                            src={LOGO_URL}
                            alt="911 Cellphone Bank"
                            className="h-9 w-9 sm:h-10 sm:w-10 object-contain"
                        />
                    </div>
                    <div className="hidden sm:block min-w-0">
                        <div className="font-display text-lg leading-none">
                            911 CELLPHONE BANK
                        </div>
                        <div className="text-[10px] uppercase tracking-widest mt-1">
                            Employee Launcher
                        </div>
                    </div>
                </Link>

                <nav className="flex items-center gap-2 sm:gap-3">
                    <NavLink
                        to="/dashboard"
                        className={navClass}
                        data-testid="nav-dashboard-link"
                    >
                        <span className="inline-flex items-center gap-1.5">
                            <LayoutGrid size={16} strokeWidth={3} />
                            <span className="hidden sm:inline">Dashboard</span>
                        </span>
                    </NavLink>
                    <NavLink
                        to="/wiki"
                        className={navClass}
                        data-testid="nav-wiki-link"
                    >
                        <span className="inline-flex items-center gap-1.5">
                            <BookOpen size={16} strokeWidth={3} />
                            <span className="hidden sm:inline">Wiki</span>
                        </span>
                    </NavLink>
                    {user?.is_admin && (
                        <NavLink
                            to="/admin"
                            className={navClass}
                            data-testid="nav-admin-link"
                        >
                            <span className="inline-flex items-center gap-1.5">
                                <Settings size={16} strokeWidth={3} />
                                <span className="hidden sm:inline">Admin</span>
                            </span>
                        </NavLink>
                    )}

                    <div
                        className="hidden sm:flex items-center gap-2 ml-1"
                        data-testid="nav-user"
                    >
                        <div className="bg-black text-white w-10 h-10 flex items-center justify-center font-display text-lg brut-border">
                            {initial}
                        </div>
                    </div>

                    <button
                        onClick={handleLogout}
                        className="font-display text-sm px-3 py-2 bg-[#E8241A] text-white brut-border brut-shadow-sm brut-press"
                        data-testid="nav-logout-btn"
                        aria-label="Log out"
                    >
                        <span className="inline-flex items-center gap-1.5">
                            <LogOut size={16} strokeWidth={3} />
                            <span className="hidden sm:inline">Logout</span>
                        </span>
                    </button>
                </nav>
            </div>
        </header>
    );
}
